module.exports = __webpack_public_path__ + "static/media/group_twophones.67e6d1bc.png";